/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {BulkProgress} from '../models/BulkProgress';
import type {Error} from '../models/Error';
import type {UpdateAccountEntitlementsResult} from '../models/UpdateAccountEntitlementsResult';
import type {UpdateEntitiesEntitlementsRelation} from '../models/UpdateEntitiesEntitlementsRelation';

export interface BulkDischargeAccountsEntitlements$Request {
    updateEntitiesEntitlementsRelation: UpdateEntitiesEntitlementsRelation;
    reason?: string;
}

export interface BulkDischargeAccountsEntitlements$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const bulkDischargeAccountsEntitlementsRequest = createAction<PayloadData<void, BulkDischargeAccountsEntitlements$Request>>('BULK_DISCHARGE_ACCOUNTS_ENTITLEMENTS__BULK_DISCHARGE_ACCOUNTS_ENTITLEMENTS__REQUEST');
export const bulkDischargeAccountsEntitlementsSuccess = createAction<PayloadData<string, BulkDischargeAccountsEntitlements$Request>>('BULK_DISCHARGE_ACCOUNTS_ENTITLEMENTS__BULK_DISCHARGE_ACCOUNTS_ENTITLEMENTS__SUCCESS');
export const bulkDischargeAccountsEntitlementsFailure = createAction<PayloadData<Error, BulkDischargeAccountsEntitlements$Request, true>>('BULK_DISCHARGE_ACCOUNTS_ENTITLEMENTS__BULK_DISCHARGE_ACCOUNTS_ENTITLEMENTS__FAILURE');

export const bulkDischargeAccountsEntitlementsActions = [
    bulkDischargeAccountsEntitlementsRequest,
    bulkDischargeAccountsEntitlementsSuccess,
    bulkDischargeAccountsEntitlementsFailure
] as const;

/**
 * @param {UpdateEntitiesEntitlementsRelation} meta.updateEntitiesEntitlementsRelation
 * @param {string} [meta.reason] Optional audit reason for this update. Blank values use the existing operation-specific reason.
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const bulkDischargeAccountsEntitlements = (meta: BulkDischargeAccountsEntitlements$Request, config?: BulkDischargeAccountsEntitlements$Config) => {
    const TRANSPORT_GET_PARAMS = {
        reason: meta.reason,
    };
    return {
        CALL_API: {
            types: bulkDischargeAccountsEntitlementsActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/bulk-actions/accounts/entitlements/discharge`,
            TRANSPORT_GET_PARAMS,
            TRANSPORT_REQUEST_BODY: meta.updateEntitiesEntitlementsRelation,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetDischargeAccountsEntitlementsProgress$Request {
    id: string;
}

export interface GetDischargeAccountsEntitlementsProgress$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getDischargeAccountsEntitlementsProgressRequest = createAction<PayloadData<void, GetDischargeAccountsEntitlementsProgress$Request>>('BULK_DISCHARGE_ACCOUNTS_ENTITLEMENTS__GET_DISCHARGE_ACCOUNTS_ENTITLEMENTS_PROGRESS__REQUEST');
export const getDischargeAccountsEntitlementsProgressSuccess = createAction<PayloadData<BulkProgress, GetDischargeAccountsEntitlementsProgress$Request>>('BULK_DISCHARGE_ACCOUNTS_ENTITLEMENTS__GET_DISCHARGE_ACCOUNTS_ENTITLEMENTS_PROGRESS__SUCCESS');
export const getDischargeAccountsEntitlementsProgressFailure = createAction<PayloadData<Error, GetDischargeAccountsEntitlementsProgress$Request, true>>('BULK_DISCHARGE_ACCOUNTS_ENTITLEMENTS__GET_DISCHARGE_ACCOUNTS_ENTITLEMENTS_PROGRESS__FAILURE');

export const getDischargeAccountsEntitlementsProgressActions = [
    getDischargeAccountsEntitlementsProgressRequest,
    getDischargeAccountsEntitlementsProgressSuccess,
    getDischargeAccountsEntitlementsProgressFailure
] as const;

/**
 * @param {string} meta.id Bulk operation id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getDischargeAccountsEntitlementsProgress = (meta: GetDischargeAccountsEntitlementsProgress$Request, config?: GetDischargeAccountsEntitlementsProgress$Config) => {
    const TRANSPORT_GET_PARAMS = {
        id: meta.id,
    };
    return {
        CALL_API: {
            types: getDischargeAccountsEntitlementsProgressActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/bulk-actions/accounts/entitlements/discharge/progress`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetDischargeAccountsEntitlementsResult$Request {
    id: string;
}

export interface GetDischargeAccountsEntitlementsResult$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getDischargeAccountsEntitlementsResultRequest = createAction<PayloadData<void, GetDischargeAccountsEntitlementsResult$Request>>('BULK_DISCHARGE_ACCOUNTS_ENTITLEMENTS__GET_DISCHARGE_ACCOUNTS_ENTITLEMENTS_RESULT__REQUEST');
export const getDischargeAccountsEntitlementsResultSuccess = createAction<PayloadData<UpdateAccountEntitlementsResult, GetDischargeAccountsEntitlementsResult$Request>>('BULK_DISCHARGE_ACCOUNTS_ENTITLEMENTS__GET_DISCHARGE_ACCOUNTS_ENTITLEMENTS_RESULT__SUCCESS');
export const getDischargeAccountsEntitlementsResultFailure = createAction<PayloadData<Error, GetDischargeAccountsEntitlementsResult$Request, true>>('BULK_DISCHARGE_ACCOUNTS_ENTITLEMENTS__GET_DISCHARGE_ACCOUNTS_ENTITLEMENTS_RESULT__FAILURE');

export const getDischargeAccountsEntitlementsResultActions = [
    getDischargeAccountsEntitlementsResultRequest,
    getDischargeAccountsEntitlementsResultSuccess,
    getDischargeAccountsEntitlementsResultFailure
] as const;

/**
 * @param {string} meta.id Bulk operation id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getDischargeAccountsEntitlementsResult = (meta: GetDischargeAccountsEntitlementsResult$Request, config?: GetDischargeAccountsEntitlementsResult$Config) => {
    const TRANSPORT_GET_PARAMS = {
        id: meta.id,
    };
    return {
        CALL_API: {
            types: getDischargeAccountsEntitlementsResultActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/bulk-actions/accounts/entitlements/discharge`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface StopBulkActions$Request {
    id: string;
}

export interface StopBulkActions$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const stopBulkActionsRequest = createAction<PayloadData<void, StopBulkActions$Request>>('BULK_DISCHARGE_ACCOUNTS_ENTITLEMENTS__STOP_BULK_ACTIONS__REQUEST');
export const stopBulkActionsSuccess = createAction<PayloadData<void, StopBulkActions$Request>>('BULK_DISCHARGE_ACCOUNTS_ENTITLEMENTS__STOP_BULK_ACTIONS__SUCCESS');
export const stopBulkActionsFailure = createAction<PayloadData<Error, StopBulkActions$Request, true>>('BULK_DISCHARGE_ACCOUNTS_ENTITLEMENTS__STOP_BULK_ACTIONS__FAILURE');

export const stopBulkActionsActions = [
    stopBulkActionsRequest,
    stopBulkActionsSuccess,
    stopBulkActionsFailure
] as const;

/**
 * @param {string} meta.id Bulk operation id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const stopBulkActions = (meta: StopBulkActions$Request, config?: StopBulkActions$Config) => {
    const TRANSPORT_GET_PARAMS = {
        id: meta.id,
    };
    return {
        CALL_API: {
            types: stopBulkActionsActions,
            method: ApiMethods.DELETE,
            endpoint: `/web-api/bulk-actions/accounts/entitlements/discharge`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

